/**
 * @generated SignedSource<<a664763874b953d4ab8400cbbb2201a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DelegatingToRowFragment$data = {
  readonly delegatingTo: {
    readonly address: {
      readonly resolvedName: {
        readonly address: string;
        readonly name: string | null;
      };
    };
  };
  readonly " $fragmentType": "DelegatingToRowFragment";
};
export type DelegatingToRowFragment$key = {
  readonly " $data"?: DelegatingToRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DelegatingToRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DelegatingToRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Delegate",
      "kind": "LinkedField",
      "name": "delegatingTo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "address",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ResolvedName",
              "kind": "LinkedField",
              "name": "resolvedName",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "address",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Delegate",
  "abstractKey": null
};

(node as any).hash = "e620ad0a6cd0cae32a40ce5eec8515fa";

export default node;
